import styled from 'styled-components'

import { helpers } from '../../../styles/theme'

export const Empty = styled.div`
	text-align: center;
	color: ${helpers.color.text};
	font-size: 16px;
	display: flex;
	justify-content: center;
	height: 100px;
	flex-direction: column;
	row-gap: 6px;
`
